<template>
  <div class="train" v-loading="loading" element-loading-text="拼命加载中">
    <div class="">
      <div class="content clearfix">
        <!-- <div class="search">
          <el-input placeholder="请输入职位名称或公司名称" clearable @clear="onsearch" class="search_input" v-model="kw">
          </el-input>
          <el-button type="primary" class="btn" @click="onsearch">开始搜索</el-button>
        </div> -->
      </div>
    </div>
    <div class="banner">
      <div class="lf">
        <el-carousel height="426px" indicator-position="none">
          <el-carousel-item v-for="(item,index) in banner" :key="index">
            <a :href="item.picUrl" target="_blank" :title="item.adName">
              <img :src="item.picSrc" alt="">
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="rt">
        <section>
          <h1 class="title flex" style="position: relative">
            <i class="icon tv"></i>
            <span>直播预告</span>
            <router-link to="/activity/live" class="more"
                         style="position: absolute;right: 0;font-size: 14px;font-weight: 400;color: #66716c">更多
            </router-link>
          </h1>
          <div class="flex" style="height: 140px;">
            <template v-if="live.notice.length > 0">
              <div v-for="item in live.notice" class="box">
                <h2><a href="">{{ item.titile }}</a></h2>
                <p class="flex" style="flex-wrap: wrap;">
                  <span>主讲师：{{ item.perName }}</span><span>{{ item.time }}</span></p>
                <p>扫码观看直播→</p>
              </div>
              <div v-for="item in live.notice">
                <img :src="item.src" alt=""/>
              </div>
            </template>
            <div class="tips" v-else style="font-size: 18px; text-align: center;"> 当前暂无直播内容，敬请期待</div>
          </div>
        </section>
        <section class="section2">
          <h1 class="title flex">
            <i class="icon play"></i>
            <span>精彩回放</span>
          </h1>
          <div class="flex" style="height: 110px;">
            <template v-if="live.playback.length > 0">
              <div v-for="item in live.playback" class="box">
                <h2><a href="">{{ item.titile }}</a></h2>
                <p class="flex"><span>主讲师：{{ item.perName }}</span></p>
              </div>
              <div v-for="item in live.playback">
                <el-button type="primary"><a :href="item.url" target="_blank">查看回放</a></el-button>
              </div>

            </template>
          </div>
        </section>
        <div class="ad flex" @click="goRegister">
          <img src="~static/henan/job/icon.png" alt="">
          <span>培训需求登记</span>
        </div>
      </div>
    </div>
    <div class="content flex">
      <div class="content_left">
        <!-- 线下培训 -->
        <section>
          <h3 class="flex">
            <i class="icon list"></i>
            <span>线下培训</span>
            <!-- <router-link to="/training/trainList">查看更多
            <img src="@/static/hebei/index/more.png" alt="">
          </router-link> -->
          </h3>
          <ul class="list flex-wrap" style="margin-top:12px" v-if="trainList.length">
            <template v-for="(item,index) in trainList">
              <trainItem :data="item" :key="item.id"/>
            </template>
            <status type="result" v-if="trainList.length < 1"></status>
          </ul>
          <router-link class="more" to="/train/list" target="_blank">查看更多培训项目</router-link>
        </section>
        <!-- 线上课程 -->
        <section>
          <h3 class="online_h3 flex">
            <i class="icon play2"></i>
            <span>公开课</span>
            <!-- <router-link to="/training/public">查看更多
            <img src="@/static/hebei/index/more.png" alt="">
          </router-link> -->
          </h3>
          <ul class="public flex-wrap">
            <li class="box cursorP relative" v-for="(item,index) in publicList" :key="index"
                @click="goRouter('/training/publicDetail',item.id)">
              <img :src="item.imgurl" alt="" class="banners">
              <div class="info ">
                <div class="name line_clamp1">{{ item.trainName }}</div>
                <p>共{{ item.reamark }}章节</p>
              </div>
            </li>
          </ul>
          <status type="result" v-if="publicList.length < 1"></status>

          <router-link class="more" to="/training/public" target="_blank"> 查看更多公开课</router-link>
        </section>
      </div>
    </div>
    <!-- :before-close="handleClose" -->
    <el-dialog title="培训需求登记" :visible.sync="evaluateDialog" width="48%" center>

      <el-form ref="form" :rules="rules" :model="form" label-width="80px" :hide-required-asterisk="true">
        <el-form-item label="姓名">
          <span>{{ form.name }}</span>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="provinceid">
          <ThreeLink dictValue="p05" codeType="provinceid" codeLevel="3" placeholder="请选择地址" style="width:33%"
                     @setMValue="setScasValue($event,form,['provinceid','cityid','threeCityid'])"
                     :defaultValue="[form.provinceid,form.cityid,form.threeCityid]"></ThreeLink>
          <el-input style="width:65%;margin-left:2%" v-model="form.address" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="需求类型" prop="needsType">
          <el-radio-group v-model="form.needsType">
            <el-radio-button v-for="(item,index) in needDisList" :label="item.value" :key="index">{{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="需求内容" prop="needsContent">
          <Editor placeholder="请输入内容" @html="text" class="width100" v-model="form.needsContent"></Editor>
        </el-form-item>
        <el-form-item>
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="onSubmit('form')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Editor from 'components/public/editor';
import ThreeLink from '@/components/selectComponents/ThreeLink';
import trainItem from '@/components/public/trainItem';

export default {
  name: 'index',
  components: {
    trainItem,
    Editor,
    ThreeLink
  },
  metaInfo: {
    title: '职业培训-河北省残疾人就业创业网络服务平台',
    meta: [
      {
        name: 'keywords',
        content: '残疾人职业培训,残疾人公开课,残疾人技能提升,残疾人技能学习,'
      },
      {
        name: 'description',
        content:
            '河北省残疾人就业创业网络服务平台,职业培训版块为残疾人提供免费的残疾人技能提升,和公开课资源,旨在为残疾人“赋能”,残疾人可以通过职业培训版块学习到插花、剪纸、盲人按摩等技能培训。'
      }
    ]
  },
  data() {
    return {
      active: 0,
      page: {
        pageNum: 1,
        pageSize: 6
      },
      page2: {
        pageNum: 1,
        pageSize: 8,
        total: 0,
        trainP: 'p20'
      },
      queryParams: {
        addressCityId: '',
        addressProvinceId: 'p05',
        addressThreeCityId: '',
        disableLevel: '',
        disableType: '',
        heatOrder: '',
        assessOrder: '',
        registrationStatus: '',
        trainIng: '',
        trainType: '',
        pageNum: 1,
        pageSize: 6
      },
      kw: '',
      adList: [],
      banner: [],
      mechanismList: [],
      trainList: [],
      publicList: [],
      live: {
        playback: [],
        notice: []
      },
      loading: false,
      evaluateDialog: false,
      flag: true,
      cityList: [],
      needDisList: [
        {value: '培训项目', label: '培训项目'},
        {value: '培训课程', label: '培训课程'},
        {value: '培训质量', label: '培训质量'},
        {value: '其他培训需求', label: '其他培训需求'}
      ],
      form: {
        name: '',
        phone: 0,
        region: '',
        needsType: '',
        needsContent: '',
        userType: '',
        addressProvinceid: '',
        addressCityid: '',
        addressThreeid: '',
        provinceid: '',
        threeCityid: ''
      },
      rules: {
        phone: [{required: true, message: '请输入电话', trigger: 'blur'}],
        provinceid: [{required: true, message: '地点不能为空', trigger: 'blur'}],
        needsType: [{required: true, message: '请选择培训项目', trigger: 'change'}],
        needsContent: [{required: true, message: '请填写培训需求', trigger: 'blur'}]
      }
    };
  },
  methods: {
    onsearch() {
      this.train();
      this.publicApi();
    },
    text(val) {
      this.form.needsContent = val;
    },
    //省市区三级联动
    setScasValue(event, form, keys) {
      for (let i = 0; i < keys.length; i++) {
        let value = event[i];
        if (!value) {
          value = '';
        }
        let key = keys[i];
        form[key] = value;
      }
    },
    //培训需求登记
    goRegister() {
      if (this.$store.state.userType || localStorage.getItem('userInfo')) {
        this.evaluateDialog = true;
        this.flag = true;
        this.form.name = JSON.parse(localStorage.getItem('userType')).linkman;
        this.form.phone = JSON.parse(localStorage.getItem('userType')).linkphone;
        this.form.userType = JSON.parse(localStorage.getItem('userType')).userType;
      } else {
        this.$message.error('请先登录');
      }
    },
    // 登记确定
    onSubmit(form) {
      let msec = new Date().getTime() + 1000 * 60 * 60 * 24 * 3; //  三天后的毫秒数
      let date = this.$dateFormat(new Date(msec)).substring(0, 10).split('-').join('/'); //三天后的时间
      this.$refs[form].validate(async valid => {
        if (valid) {
          let res = await this.$api.addNeed({
            needsType: this.form.needsType,
            expectTime: date,
            needsContent: this.form.needsContent,
            userType: this.form.userType,
            province: 'p05',
            city: this.form.cityid,
            linkphone: this.form.phone,
            remark: 'hebei'
          });
          if (res.data.success) {
            this.$message.success('培训需求登记成功');
            this.evaluateDialog = false;
          } else {
            this.$message.error(res.message);
          }
        } else {
          // this.$message.error("请填写内容在提交")
          return false;
        }
      });
    },
    close() {
      this.flag = true;
      this.evaluateDialog = false;
    },
    //直播预告
    notice() {
      this.$api
          .zhiboActivityListApi({
            pageNum: 1,
            pageSize: 1,
            // zhiboType:1,
            timeStatus: 3, // （1未开始  2 已结束  3未开始和进行中）
            provinceid: 'p20'
          })
          .then(res => {
            if (res.data.success) {
              res = res.data?.data ?? {};
              if (res.records) {
                this.live.notice = res.records;
                console.log(122333, this.live.notice)
                // this.live = res.records.reduce(
                //   (acu, item, index) => {
                //     // 0 进行中 可以直播 1 未开始 2 已结束
                //     if (item.timeStatus == 1) {
                //       acu.notice.push({ ...item })
                //     }
                //     if (item.timeStatus == 2) {
                //       acu.playback.push({ ...item })
                //     }
                //     return acu
                //   },
                //   { playback: [], notice: [] }
                // )
              }
            }
          });
    },
    getHuiFang() {
      this.$api
          .zhiboActivityListApi({
            pageNum: 1,
            pageSize: 1,
            // zhiboType:1,
            provinceid: 'p20',
            timeStatus: 2
          })
          .then(res => {
            if (res.data.success) {
              res = res.data?.data ?? {};
              if (res.records) {
                // console.log(res.records);
                this.live.playback = res.records;
              }
            }
          });
    },
    // tab(i){
    //   this.active = i;
    //   this.page.pageNum = 1;
    //   if (i == 0){
    //     this.train();
    //   }else{
    //     this.publicApi();
    //   }
    // },
    async train() {
      this.loading = true;
      try {
        this.$api
            .queryCourseList({
              // ...this.page,
              ...this.queryParams,
              trainName: this.kw
            })
            .then(res => {
              this.loading = false;
              res = res.data;
              if (res.success) {
                const {records, total} = res.data.courseListOutDTOIPage;
                this.trainList = (records ?? []).map(item => {
                  return {
                    ...item,
                    disType: item.disType ? JSON.parse(item.disType) : []
                  };
                });
                this.page.total = total;
              }
            });
      } catch (e) {
      }
    },
    async publicApi() {
      try {
        let res = await this.$api.publicListApi({
          ...this.page2,
          trainName: this.kw
        });
        this.publicList = res.data.data.records;
        this.page2.total = res.data.data.total;
      } catch (e) {
      }
    },
    //广告 轮播图
    async ad() {
      try {

        let red = await this.$api.adApi({
          classId: 'ff80808177d6b63a0177d8304ecd0004'
        });
        this.banner = red.data.data;
      } catch (e) {
      }
    },
    async mechanism() {
      try {
        let res = await this.$api.mechanismListApi({
          pageNum: 1,
          pageSize: 6,
          provinceId: 'p22'
        });
        this.mechanismList = res.data.data.records;
        this.ad();
      } catch (e) {
      }
    },
    goRouter(url, id) {
      const {href} = this.$router.resolve({
        path: url,
        query: {
          id: id
        }
      });
      window.open(href);
    },
    //分页
    handleCurrentChange: function (val) {
      this.page.pageNum = val;
      if (this.active == 0) {
        this.train();
      } else {
        this.publicApi();
      }
      window.scrollTo(0, 400);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    }
  },
  created() {
    this.train();
    this.mechanism();
    this.publicApi();
    this.notice();
    this.getHuiFang();
  }
};
</script>

<style src='./css/train.less' scoped lang="less">
</style>
